import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

interface Props {
  size?: number;
  children?: React.ReactNode;
  isLoading?: boolean;
}

const LoadingComponent: React.FC<Props> = ({ children, isLoading, size = 12 }) => {
  if (isLoading) {
    return <CircularProgress size={size} />;
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return children ? <>{children}</> : null;
};

export default LoadingComponent;
